import { render, staticRenderFns } from "./CrossAssessment.vue?vue&type=template&id=67f62bac&"
import script from "./CrossAssessment.vue?vue&type=script&lang=js&"
export * from "./CrossAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports